import { v4 as uuid } from 'uuid';

import { MINIMAL_NODES } from '@/data/minimal-nodes';
import { initialBotsData } from '@/data/prompt-edit-data';
import { Bot } from '@/domain/bot';
import { BotMappieVersion } from '@/domain/bot-mappie';

/**
 * Initial state for the editable bot version slice.
 * Contains all default values for the store.
 */
export interface EditableBotVersionInitialState {
    itemsUndo: Bot[];
    itemsRedo: Bot[];
    mappieBot: BotMappieVersion;
    globalPromptUpdated: boolean;
    editingBot: Bot;
    currentBotVersion: string;
    lastTimeChangedUndoStack: number;
    lastTimeUndoOrRedo: number;
    previousPath: string | null;
    testPhoneNumber: string | null;
    isLoadingBotVersion: boolean;
    errorFetchBotVersion?: {
        isErrorFetchBotVersion: boolean;
        errorMessageFetchBot: unknown;
        errorMessageFetchBotKey?: string;
    };
    errorSaveBotVersion?: {
        isErrorSaveBotVersion: boolean;
        errorMessageSaveBot: unknown;
        errorMessageSaveBotKey?: string;
    };
    changesInBotVersion: boolean;
    customModuleNodeHandles: Record<string, string[]>;
    addedNodePosition: number;
    currentConversationTaskId?: number;
}

export const createInitialEditingBot = (): Bot => ({
    name: '',
    description: '',
    botId: '',
    botVersionId: '',
    voiceConfig: undefined,
    smsConfig: undefined,
    language: '',
    channel: 'voice',
    taskValues: [{ variableName: '', value: '', id: uuid() }],
    nodesReactFlow: MINIMAL_NODES,
    selectedHandle: undefined,
    edgesReactFlow: [],
    stickers: {
        S1: {
            name: 'default',
            description: '',
            appearance: {
                // secondaryBgPinkDark
                color: '#fceaea',
            },
        },
    },
    labels: [],
});

export const initialState: EditableBotVersionInitialState = {
    itemsUndo: [],
    itemsRedo: [],
    mappieBot: initialBotsData,
    globalPromptUpdated: false,
    editingBot: createInitialEditingBot(),
    currentBotVersion: '',
    lastTimeChangedUndoStack: 0,
    lastTimeUndoOrRedo: 0,
    previousPath: null,
    testPhoneNumber: null,
    isLoadingBotVersion: false,
    errorFetchBotVersion: undefined,
    errorSaveBotVersion: undefined,
    changesInBotVersion: false,
    customModuleNodeHandles: {},
    addedNodePosition: 0,
    currentConversationTaskId: undefined,
};
